module.exports = "<div flex layout=\"column\" layout-align=\"center center\">\n\t<weather-forecast flex layout-fill></weather-forecast>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 5
// module chunks = 0